var exports = {
  "iE": "xaee3c4fa--3622aa--wrapper",
  "P7": "xaee3c4fa--3622aa--inner-wrapper",
  "dA": "xaee3c4fa--3622aa--rubrics",
  "CG": "xaee3c4fa--3622aa--rubric",
  "DD": "xaee3c4fa--3622aa--title",
  "Tc": "xaee3c4fa--3622aa--tag",
  "h_": "xaee3c4fa--3622aa--description",
};

module.exports = exports;
